import { createFileRoute, Outlet, useRouterState } from '@tanstack/react-router';
import { TimeTrackingDashboard } from '../components/overview/TimeTrackingDashboard';

export const Route = createFileRoute('/overview')({
  component: OverviewComponent,
});

function OverviewComponent() {
  const router = useRouterState();
  const isExactPath = router.location.pathname === '/overview';

  if (isExactPath) {
    return <TimeTrackingDashboard />;
    // return <div>Under Construction 🚧</div>;
  }

  return <Outlet />;
}

